export default __webpack_public_path__ + "static/media/MagnetoMeter.3bc2e10f.png";